/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/inbox/supplierInvoicesInbox/bulkTasksHelper"/>

export const normalizeBulkWizardTask = (task: any) => {
    if (!task) {
        return null;
    }

    const rawTaskId = task.TaskId ?? task.id;
    const rawDocumentId = task.DocumentId ?? task.documentId;
    const normalizedTaskId = Number(rawTaskId);
    const normalizedDocumentId = Number(rawDocumentId);
    const documentType = task.DocumentType ?? task.documentType ?? task?.taskGroup?.fullName ?? null;
    const description = task.TaskDescription ?? task.taskDescription ?? null;
    const indicators = task.Indicators ?? task.indicators ?? [];

    if (isNaN(normalizedTaskId) || isNaN(normalizedDocumentId)) {
        return null;
    }

    const normalizedTask: any = {
        ...task,
        id: normalizedTaskId,
        TaskId: normalizedTaskId,
        DocumentId: normalizedDocumentId,
        Activity: task.Activity,
        TaskDescription: description,
        taskDescription: description,
        Indicators: indicators,
        indicators
    };

    if (!normalizedTask.taskGroup) {
        normalizedTask.taskGroup = { fullName: documentType };
    } else if (!normalizedTask.taskGroup.fullName) {
        normalizedTask.taskGroup.fullName = documentType;
    }

    return normalizedTask;
};